import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/crm/Badges";
import { WelcomeChips } from "@/components/crm/WelcomeWhatsApp";

export const WebWelcomePanel = () => {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/web-welcome").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  return (
    <Panel title="Bienvenidas de formulario web" icon={MessageCircle} testid="web-welcome-panel"
           action={<Button variant="outline" size="sm" onClick={load} className="rounded-lg" data-testid="web-welcome-refresh"><RefreshCw className="mr-1 h-3.5 w-3.5" /> Actualizar</Button>}>
      <p className="text-sm text-slate-600">Últimos 50 pacientes del formulario web: contacto en la plataforma, etiqueta y si llegó la bienvenida por WhatsApp.</p>
      {rows && (rows.length === 0 ? <p className="mt-4 rounded-xl bg-[#F5F7FA] p-4 text-sm text-slate-500" data-testid="web-welcome-empty">Aún no hay leads del formulario web.</p> : (
        <div className="mt-4 overflow-auto">
          <table className="w-full text-left text-sm" data-testid="web-welcome-table">
            <thead className="text-xs uppercase text-slate-400"><tr><th className="py-2">Paciente</th><th>Teléfono</th><th>Vendedor</th><th>Recibido</th><th>Contacto</th><th>Bienvenida WhatsApp</th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-slate-100 align-top" data-testid={`web-welcome-row-${r.id}`}>
                  <td className="py-2 pr-3 font-medium"><Link to={`/crm/leads/${r.id}`} className="text-[#1E6FD9]">{r.name}</Link></td>
                  <td className="py-2 pr-3">{r.phone || "—"}</td>
                  <td className="py-2 pr-3">{r.seller_name || "Sin asignar"}</td>
                  <td className="py-2 pr-3 text-slate-500">{fmtDateTime(r.created_at)}</td>
                  <td className="py-2 pr-3">{r.linked ? <span className="text-emerald-600">Vinculado</span> : <span className="text-amber-600" title={r.sync_error || ""}>Pendiente de sincronización</span>}</td>
                  <td className="py-2"><WelcomeChips tagStatus={r.tag_status} welcomeAt={r.welcome_sent_at} testid={`web-welcome-status-${r.id}`} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </Panel>
  );
};
